import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

const EmptyState = ({ title, description }) => (
	<Box
		sx={{
			py: 6,
			px: 2,
			textAlign: 'center',
			border: '1px dashed',
			borderColor: 'divider',
			borderRadius: 2,
			bgcolor: 'background.paper',
		}}
	>
		<Typography variant="body1" fontWeight={600} gutterBottom>
			{title}
		</Typography>
		{description ? (
			<Typography variant="body2" color="text.secondary">
				{description}
			</Typography>
		) : null}
	</Box>
);

const MobileDataList = ({
	items = [],
	getKey,
	renderItem,
	isLoading = false,
	emptyTitle = 'Nothing here yet',
	emptyDescription,
	filters = null,
	footer = null,
	spacing = 1.5,
	sx,
	listSx,
}) => (
	<Stack spacing={spacing} sx={{ pb: 10, ...sx }}>
		{filters}
		{isLoading ? (
			<Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
				<CircularProgress size={32} />
			</Box>
		) : !items.length ? (
			<EmptyState title={emptyTitle} description={emptyDescription} />
		) : (
			<Stack spacing={spacing} sx={listSx}>
				{items.map((item, index) => {
					const key = getKey ? getKey(item, index) : (item.id ?? index);
					return (
						<React.Fragment key={key}>{renderItem(item, index)}</React.Fragment>
					);
				})}
			</Stack>
		)}
		{footer}
	</Stack>
);

export default MobileDataList;
